module.exports = __webpack_public_path__ + "static/img/hongkong.dad183d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/universityHall/images/hongkong.png
// module id = HkmS
// module chunks = 0